@if (location) {
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ location.locationName }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @for (role of roles; track role) {
        <mat-checkbox
          [disabled]="disableOwnRoles"
          [checked]="hasRole(role.id, location.locationID)"
          (change)="onSelected($event.source.checked, role, location.locationID)">
          {{role.name }}
        </mat-checkbox>
      }
    </mat-card-content>
    @if (showErrorMessage) {
      <mat-error>
        A user cannot have JM Care Plan Repair and JM Care Plan Jeweler roles for the same location.
      </mat-error>
    }
  </mat-card>
}
<app-in-progress [loading]="isLoading"> </app-in-progress>